import { BaseService } from "../BaseService";

export class AuthService extends BaseService {
  public async confirmEmail(email: string, token: string): Promise<void> {
    return this.postRequest(
      `/auth/v1/confirm-email`,
      { email, token },
      "",
      true,
      true,
    );
  }

  public async resendConfirmationEmail(email: string): Promise<void> {
    return this.postRequest(
      `/auth/v1/resend-confirm-email?email=${encodeURIComponent(email)}`,
      null,
      "",
      true,
      true,
    );
  }

  public async sendPasswordReset(email: string): Promise<void> {
    return this.postRequest(
      `/auth/v1/send-password-reset?email=${encodeURIComponent(email)}`,
      null,
      "Password reset sent",
    );
  }

  public async confirmPasswordReset(
    email: string,
    token: string,
    password: string,
  ): Promise<void> {
    return this.postRequest(
      `/auth/v1/confirm-password-reset`,
      {
        email,
        token,
        password,
      },
      "Password reset confirmed",
    );
  }

  public async sendMagicLink(email: string): Promise<void> {
    return this.postRequest(
      `/auth/v1/send-magic-link?email=${encodeURIComponent(email)}`,
      null,
      "Magic link sent",
    );
  }

  public async signOut(refreshToken: string): Promise<void> {
    return this.postRequest(
      `/auth/v1/logout`,
      { token: refreshToken },
      "",
      true,
      true,
    );
  }

  public async exchangeTransferToken(transferToken: string): Promise<{
    access_token: string;
    refresh_token: string;
    expires_in: number;
  }> {
    return this.postRequest(
      `/auth/v1/exchange-transfer-token`,
      { transfer_token: transferToken },
      "",
      true,
      true,
    );
  }
}

export const authService = new AuthService();
